type CacheKey = string;
type CacheValue = any;

class MemoryCache {
  private cache: Record<CacheKey, CacheValue> = {};

  public set<T = any>(key: CacheKey, value: T): void {
    this.cache[key] = value;
  }

  public get<T = any>(key: CacheKey): T | undefined {
    return this.cache[key];
  }

  public clear(key: CacheKey): void {
    delete this.cache[key];
  }

  public clearAll(): void {
    this.cache = {};
  }
}

export const memoryCache = new MemoryCache();
